import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useConfig } from '../context/ConfigContext';
import { updateAppThemes } from '../utils/api'; // Import our new function
import { hasRole } from '../utils/auth';

const AppSettingsPage: React.FC = () => {
    const navigate = useNavigate();
    const { settings, loadingSettings, refreshSettings } = useConfig();
    
    // Local state to manage toggles before saving
    const [themeData, setThemeData] = useState<any>(null);

    useEffect(() => {
        if (!hasRole(['super_admin'])) {
            navigate('/');
        }
        // Initialize local state when settings load
        if (settings?.themes) {
            setThemeData(settings.themes);
        }
    }, [settings, navigate]);

    if (loadingSettings || !themeData) return <div className="p-10">Loading...</div>;

    // Function to handle toggle changes
    const handleToggle = (key: string) => {
        setThemeData((prev: any) => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    // Save to Database
    const saveSettings = async () => {
        try {
            await updateAppThemes(themeData);
            toast.success("Settings saved to server!");
            refreshSettings(); // Refresh the global context
        } catch (err: any) {
            toast.error(err.message);
        }
    };

    return (
        <div className="container mx-auto p-4 max-w-xl">
            <h1 className="text-2xl font-bold mb-6">Store Visibility Settings</h1>
            
            <div className="space-y-4 bg-white p-6 rounded-xl shadow-md border">
                {/* Reusable Toggle Row */}
                {[
                    { key: 'show_add2cart', label: 'Allow Add to Cart' },
                    { key: 'show_prices', label: 'Display Prices to Public' },
                    { key: 'show_suppliers', label: 'Show Supplier Info' }
                ].map((item) => (
                    <div key={item.key} className="flex justify-between items-center py-2 border-b">
                        <span className="text-gray-700 font-medium">{item.label}</span>
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input 
                                type="checkbox" 
                                checked={themeData[item.key] || false} 
                                onChange={() => handleToggle(item.key)}
                                className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                        </label>
                    </div>
                ))}

                <button 
                    onClick={saveSettings}
                    className="w-full mt-6 bg-green-600 text-white font-bold py-3 rounded-lg hover:bg-green-700 transition shadow-lg"
                >
                    SAVE CHANGES
                </button>
            </div>
        </div>
    );
};

export default AppSettingsPage;